import { CommonModule } from '@angular/common';
import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { Observable } from 'rxjs';
import { SingleStepComponent } from '../common/step-progress-tracker/single-step/single-step.component';
import { StepProgressTrackerComponent } from '../common/step-progress-tracker/step-progress-tracker.component';
import { GuideNavigationService } from './services/guide-navigation.service';
import { GUIDE_SERVICE } from './tokens';
import { CurrentRouteConfig, GuideServiceProvider } from './types';

@Component({
  selector: 'app-topic',
  templateUrl: './guide.component.html',
  styleUrls: ['./guide.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, StepProgressTrackerComponent, SingleStepComponent, RouterModule],
  providers: [GuideNavigationService],
})
export class GuideComponent {
  guideNavService: GuideNavigationService;

  constructor(
    @Inject(GUIDE_SERVICE) private guideService: GuideServiceProvider,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {
    this.guideNavService = new GuideNavigationService(router, activatedRoute);

    this._initFirstStep();
  }

  get items(): Observable<CurrentRouteConfig[]> {
    return this.guideNavService.currentRouteConfig;
  }

  get nextButtonText(): string {
    // If the current route is the last route in the guide, then the next button should say "Start exploring".
    if (this.guideNavService.isLastRoute) {
      return 'Start exploring';
    } else {
      return 'Continue';
    }
  }

  public close() {
    this.guideService.markGuideCompleted();
    this.router.navigate(['/results']);
  }

  public continue() {
    if (this.guideNavService.isLastRoute) {
      this.guideNavService.next();
      this.guideService.markGuideCompleted();
      this.close();
    } else {
      this.guideNavService.next();
    }
  }

  /**
   * Checks if the current route is the last route in the guide.  If it is navigate to the first step.
   * This is used to reset the guide in the event the user navigates back to the guide after completing it.
   * Forces the user to start at the beginning of the guide.
   */
  private _initFirstStep(): void {
    if (this.router.url.includes(this.guideNavService.getLastRoutePath())) {
      this.router.navigate([this.guideNavService.baseUrl]);
    }
  }
}
